<template>
  <div class="sign u-overlay u-row u-center u-middle u-overflow-y-scroll u-pad-y-md">
    <app-form-login class="u-relative" :isNew="false" />
    <div v-show="!$device.isTablet" @click="$router.push($local('create'))" class="t-link change-page t-text t-text--small u-grey-light">
      {{$t('login.alreadyCreate')}}
    </div>
  </div>
</template>

<script>
import AppFormLogin from '@/components/common/AppFormLogin'

export default {
  components: {
      AppFormLogin
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'

.sign
  &:before
    position fixed
    
.change-page
  position absolute
  top $spacings.md
  right $spacings.md

</style>
